import AACChromeInternalAPI from '@amzn/aac-chrome-internal-api'
import {Region, CountryLink, DetailAccountInfo, CountryLinksWithRegion, WeblabedFeatures, Feature, RegionLink} from './Types';
import {ADSPGlobalBuyingSupportedRegions} from "src/constants/ADSPGlobalBuyingConstants";

const getNumericRegionOrdering = (region: Region) => {
  switch (region){
    case Region.NA: return 1;
    case Region.APAC: return 2;
    case Region.EU: return 3;
    default: return 0;
  }
};

export const getRegionLinks = (account: DetailAccountInfo | undefined) => {
  if (!account) {
    return [];
  }
  const accounts = account.nestedAccounts;
  // When there's no nested accounts, only one region is available for user to choose
  if (accounts.length === 0) {
    return [
      {
        region: account.regionId,
        url: account.url,
      },
    ];
  }
  return accounts.filter(account => ADSPGlobalBuyingSupportedRegions.includes(account.regionId))
      .map((account)=> {
        return {
          region: account.regionId,
          url: account.url
        }
      }).sort((a, b) => {return getNumericRegionOrdering(a.region) - getNumericRegionOrdering(b.region)});
}

export const getCountryLinksByRegion = (account: DetailAccountInfo | undefined) => {
  if (!account) {
    return [];
  }

  const accounts = account.nestedAccounts;

  // When there's no nested accounts, only one country is available for user to choose
  if (accounts.length === 0) {
    const countryLinks = [{
      country: account.marketplaceName || '',
      url: account.url
    }];

    return [{
      region: account.regionId,
      countryLinks: countryLinks
    }];
  }

  // Initialize the map with fixed region order
  const regions = [Region.NA, Region.EU, Region.APAC, Region.MENA, Region.SA];
  const regionToCountryLinks = new Map<Region, CountryLinksWithRegion>();
  regions.forEach((region) => {
    regionToCountryLinks.set(region, {region: region, countryLinks: []});
  });

  accounts.forEach((account) => {
    if (regionToCountryLinks.has(account.regionId)) {
      const countryLink: CountryLink = {
        country: account.marketplaceName || '',
        url: account.url
      };
      regionToCountryLinks.get(account.regionId)?.countryLinks.push(countryLink);
    }
  });

  return Array.from(regionToCountryLinks.values());
}

export const findFeatureLaunchInfo = (
  featureName: WeblabedFeatures,
): Feature | undefined => {
  const internalChromeContext = getInternalChromeConfig();
  if (!internalChromeContext.featureLaunchInfo) {
    return undefined;
  }

  return internalChromeContext.featureLaunchInfo.features.find(
    (feature) => feature.name === featureName && feature.isEnabled,
  );
};

export const getInternalChromeConfig = () => {
  if (!!document.querySelector('meta[name="a2z:mons_site_name"]')) {
    return window.AACChrome.InternalAPI.InternalChromeConfigHandler.getInstance().internalChromeConfig
  }
 
  return AACChromeInternalAPI.getChromeContext()
}